<template>
  <svg width="100px" height="100px"
       viewBox="0 0 30 30" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Pidz Silhouette</title>
    <g id="silhouette" stroke="none"
       stroke-width="1" fill="none"
       fill-rule="evenodd">
      <path d="M15,3.5 C18.0475602,3.5 20.5180959,5.97053571 20.5180959,9.01809595 C20.5180959,9.17194256 20.511662,9.32572188 20.498811,9.47903082 L20.4086038,10.5551746 C20.1742863,13.3505098 17.8370777,15.5 15.0319389,15.5 C12.222884,15.5 9.87858478,13.3553925 9.6291534,10.5574336 L9.53277285,9.47629928 C9.26359463,6.4568331 11.4931435,3.79086007 14.5126097,3.52168185 C14.6746715,3.50723443 14.8372955,3.5 15,3.5 Z" id="Rectangle-Copy-2"
            fill="#80A6CE" fill-rule="nonzero"></path>
      <path d="M19.066141,18 C21.8946663,18 24.401762,19.7541578 25.1982043,22.3352259 L25.9504196,24.7729654 C26.129404,25.3530086 25.8085298,25.9696449 25.2337272,26.1502611 C24.6589245,26.3308773 5.37269982,26.3068409 4.79343691,26.1413702 C4.21417401,25.9758996 3.8775172,25.3678925 4.04149288,24.7833484 L4.67343412,22.5305905 C5.42624484,19.8469544 8.00049506,18 10.9213671,18 L19.066141,18 Z" id="Path"
            fill="#80A6CE" fill-rule="nonzero"></path>
    </g>
  </svg>
</template>
<script setup>
// dummy comment to surpress rollup build errors with dynamic imports
// if the file doesn't contain a script tag with content, the build fails.
</script>
